import React  ,{ Component } from 'react';

class Footer extends Component{

    constructor(props){
        super(props);     
    }

  
    
    render(){
        return(
                 
               
        <>
         
        <div className="footer">
      
        <div className="aboutme">
           <p className= "name">A project by <a href="https://www.linkedin.com/in/deepakchauhan22/">Deepak Chauhan</a></p>
        </div>
         </div>
        </>
     

        );
    }
}
export default Footer;
